function Checkbox(props) {
  return (
    <div className="flex items-center gap-2">
      <input type="checkbox" className="w-5 h-5" />
      <p>{props.title}</p>
    </div>
  );
}
export default Checkbox;
